<style>
.title{
   margin-right: 110px;
   font-family: 'Mpass-Bold';
  }
  h1 {
    font-size: 2rem;
  }
</style>
<script>
import Footer from '@/components/shared/footer/footer'

export default {
  name: 'PageNotFoundComponent',
  components: {
    'app-footer': Footer
  },
  data () {
    return {
      message: 'Uh oh!',
      subMessage: '404 Error: Page not found'
    }
  },
  mounted () {
    this.$store.commit('lightBoxloaderOn', false)
  },

  methods: {}
}
</script>

<template>
  <div id="page-not-found">
    <nav
      id="primary-nav"
      class="navbar navbar-light navbar-expand-xl py-3 sticky-top bg-white border-bottom">
      <header class="p-0 container-fluid bg-white">
        <div class="container-xl bg-white d-flex align-items-center">
          <div>
            <a
              data-link-type="internal"
              href="/testingtools">
              <img
                src="@/assets/images/mc_srci.png"
                alt="Logo">
            </a>
          </div>
          <div class="p-0 title flex-grow-1 text-center">
            <h1 class="font-weight-bold cursor-pointer">
              Click to Pay Testing and Support Tools
            </h1>
          </div>
        </div>
      </header>
    </nav>
    <div
      class="container-fluid d-flex h-100 p-0 flex-column flex-lg-row bg-white"
    >
      <div
        id="main-content"
        class="h-100 d-flex flex-column flex-grow-1 position-relative"
      >
        <div
          id="inner-content"
          class="flex-grow-1">
          <div>
            <div class="container-xl">
              <div class="row py-5 mt-5">
                <div class="col-md-6">
                  <h1>{{ message }}</h1>
                  <h4 class="text-nowrap">
                    <span>{{ subMessage }}<br ></span>
                  </h4>
                  <router-link
                    to="/testingtools"
                    class="btn btn-lg btn-primary mt-3"
                  >Go Home</router-link
                  >
                </div>
                <div class="col-md-6">
                  <img
                    class="error-container__bg"
                    src="@/assets/images/error.png"
                    alt="error"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-footer />
  </div>
</template>
